<!--
	MyPartnersPage.svelte
-->

<script>
    import { onMount } from 'svelte';
    import { fly, fade } from 'svelte/transition';

    // TCARE components
    import PageBanner from '../../components/common/PageBanner.svelte';

    // SMUI components


    onMount(() => {
        // NEED LOGIN CHECK HERE!
        window.scrollTo(0, 0);          // do this for all other pages!
    })

</script>

<style>
    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="page-content" in:fly="{{ x: 200, duration: 500 }}" out:fade="{{ duration: 250 }}">
    <div class="spacer-h-25"></div>
    <PageBanner title="My Partners - manage your Partners"/>
    <div class="spacer-h-25"></div>

    <div class="fs-1 ta-l" >
        My Partners Page coming soon!
    </div>
    
</div>
